import React, { useCallback, useEffect } from 'react'

import VTTParser from './VTTParser'

import type { TrickImages } from './types'

export function useVTTParser(url: string) {
  const [vttParsedData, setVttParsedData] = React.useState<null | TrickImages>(
    null
  )

  const getParsedVTTData = useCallback(async () => {
    const vttParsed = await VTTParser(url)
    setVttParsedData(vttParsed)
  }, [url])

  useEffect(() => {
    if (url) {
      getParsedVTTData()
    }
  }, [url])
  return vttParsedData
}
